export const fontFamily = 'Inter, -apple-system, "system-ui", sans-serif'
